// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileFollowers_wrapper__WidMn","title":"ProfileFollowers_title__s0Dnt"};